import {useState, useEffect, useCallback} from "react";
import useCartState from "../hooks/useCartState";
import debounce from "lodash/debounce";

function SetItemQuantity({item, render}) {
  const [quantity, setQuantity] = useState(item.getQuantity());
  const [cartState, Actions] = useCartState();

  useEffect(() => {
    setQuantity(item.getQuantity());
  }, [cartState.data, item, setQuantity]);

  const updateItem = useCallback(
    debounce((cart, newItem) => {
      Actions.updateItem(cart, newItem);
    }, 500),
    [Actions]
  );
  const updateItemQuantity = newQuantity => {
    setQuantity(newQuantity);
    const newItem = item.setQuantity(newQuantity);
    updateItem(cartState.data, newItem);
  };
  return render({quantity, setQuantity: updateItemQuantity});
}

export default SetItemQuantity;
